import { render } from "./AboutSection.vue?vue&type=template&id=0adaa968&scoped=true"
import script from "./AboutSection.vue?vue&type=script&lang=js"
export * from "./AboutSection.vue?vue&type=script&lang=js"

import "./AboutSection.vue?vue&type=style&index=0&id=0adaa968&scoped=true&lang=scss"
import "./AboutSection.vue?vue&type=style&index=1&id=0adaa968&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0adaa968"]])

export default __exports__